import { render, staticRenderFns } from "./view-approval.vue?vue&type=template&id=d0e4e7be&"
import script from "./view-approval.vue?vue&type=script&lang=ts&"
export * from "./view-approval.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports